import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetStressAssessmentSchedule } from '~/usecases/useGetStressAssessmentSchedule';

type ReturnType = {
  isDisplayBanner: boolean;
};

/**
 * ストレスチェック実施バナーの表示フラグを取得するhook。
 */
export const useGetScheduleNotificationBannerStatus = (): ReturnType => {
  const threeLetterCode = getThreeLetterCode();
  const { data } = useGetStressAssessmentSchedule({
    threeLetterCode,
  });
  const isDisplayBanner = data?.stress_check_schedule?.show_implementation_banner ?? false;
  return { isDisplayBanner };
};
